import React, { useState } from 'react';

interface AdminPanelProps {
  modules: any[];
  onAddLesson: (moduleId: number, title: string, duration: string, content: string) => void;
  onClose: () => void;
}

const AdminPanel: React.FC<AdminPanelProps> = ({ modules, onAddLesson, onClose }) => {
  const [formData, setFormData] = useState({
    moduleId: modules[0]?.id || '',
    title: '',
    duration: '',
    content: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.moduleId || !formData.title || !formData.content) return;
    
    onAddLesson(
      Number(formData.moduleId),
      formData.title,
      formData.duration || '10 min',
      formData.content
    );
    
    // Reset form
    setFormData({
      moduleId: modules[0]?.id || '',
      title: '',
      duration: '',
      content: ''
    });
    
    alert('Aula adicionada com sucesso! (Simulado)');
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-[2.5rem] w-full max-w-2xl overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-300">
        <div className="p-8 border-b border-gray-100 flex items-center justify-between bg-indigo-50/50">
          <div>
            <h2 className="text-2xl font-black text-gray-900">Painel do Administrador</h2>
            <p className="text-indigo-600 text-sm font-bold uppercase tracking-wider mt-1">Adicionar Nova Aula</p>
          </div>
          <button 
            onClick={onClose}
            className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-gray-400 hover:text-gray-900 shadow-sm transition-colors"
          >
            ✕
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-8 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="text-xs font-black text-gray-400 uppercase tracking-widest px-1">Módulo</label>
              <select 
                value={formData.moduleId}
                onChange={(e) => setFormData({...formData, moduleId: e.target.value})}
                className="w-full bg-gray-50 border-2 border-gray-100 rounded-2xl px-4 py-3 font-bold text-gray-700 focus:border-indigo-500 focus:outline-none transition-colors"
                required
              >
                {modules.map(m => (
                  <option key={m.id} value={m.id}>{m.emoji} {m.title}</option>
                ))}
              </select>
            </div>
            
            <div className="space-y-2">
              <label className="text-xs font-black text-gray-400 uppercase tracking-widest px-1">Duração (ex: 15 min)</label>
              <input 
                type="text" 
                value={formData.duration}
                onChange={(e) => setFormData({...formData, duration: e.target.value})}
                placeholder="10 min"
                className="w-full bg-gray-50 border-2 border-gray-100 rounded-2xl px-4 py-3 font-bold text-gray-700 focus:border-indigo-500 focus:outline-none transition-colors"
              />
            </div>
          </div>
          
          <div className="space-y-2">
            <label className="text-xs font-black text-gray-400 uppercase tracking-widest px-1">Título da Aula</label>
            <input 
              type="text" 
              value={formData.title}
              onChange={(e) => setFormData({...formData, title: e.target.value})}
              placeholder="Ex: Anatomia do Joelho"
              className="w-full bg-gray-50 border-2 border-gray-100 rounded-2xl px-4 py-3 font-bold text-gray-700 focus:border-indigo-500 focus:outline-none transition-colors"
              required
            />
          </div>
          
          <div className="space-y-2">
            <label className="text-xs font-black text-gray-400 uppercase tracking-widest px-1">Conteúdo da Aula</label>
            <textarea 
              value={formData.content}
              onChange={(e) => setFormData({...formData, content: e.target.value})}
              placeholder="Descreva o conteúdo da aula aqui..."
              rows={5}
              className="w-full bg-gray-50 border-2 border-gray-100 rounded-2xl px-4 py-3 font-bold text-gray-700 focus:border-indigo-500 focus:outline-none transition-colors resize-none"
              required
            />
          </div>
          
          <div className="pt-4">
            <button 
              type="submit"
              className="w-full bg-indigo-600 text-white py-4 rounded-2xl font-black text-lg hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-200 active:scale-[0.98]"
            >
              ADICIONAR AULA AO CURSO
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminPanel;
